/* global $ */

import Events from '../config/events'

export default class NavigationManager {
  constructor() {
    this.initBehavior()
  }

  initBehavior() {
    $('body')
      .on(Events.ON_NAVIGATION_OPEN, this.closeSearch.bind(this))
      .on(Events.ON_NAVIGATION_SEARCH_OPEN, this.closeNavigation.bind(this))
  }

  closeSearch() {
    this.closeElem('js-navigation-search-bar--open')
  }

  closeNavigation() {
    this.closeElem('navigation--active')
  }

  closeElem(openClass) {
    $(`.${openClass}`).removeClass(openClass)
  }
}
